import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SquirrelEnvironmentDto } from 'projects/shared/src/lib/models/SquirrelEnvironmentDto';
import { DatabaseMigrationService } from 'projects/shared/src/lib/services/database-migration.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'delete-squirrel-environment-dialog',
  templateUrl: './delete-squirrel-environment-dialog.component.html',
  styleUrls: ['./delete-squirrel-environment-dialog.component.scss']
})
export class DeleteSquirrelEnvironmentDialogComponent implements OnInit {

  squirrelEnvironmentForm!: FormGroup;
  sqEnvDto!: SquirrelEnvironmentDto;

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<DeleteSquirrelEnvironmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private databaseMigrationService: DatabaseMigrationService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.createsquirrelEnvironmentForm();
  }

  createsquirrelEnvironmentForm() {
    this.squirrelEnvironmentForm = this.fb.group({
      id: [this.data.id],
      name: [this.data.name]
    });
  }

  delete(id: string) {
    if (this.squirrelEnvironmentForm.valid) {
      this.databaseMigrationService.deleteSquirrelEnvironment(id).subscribe({
        next: (data) => {
        }
      });
      this.dialogRef.close(this.squirrelEnvironmentForm.value);
    }
  }
  cancel(){
    this.dialogRef.close();
  }

}
